export default "__VITE_ASSET__BkARk8e6__"